import classesCss from "./AboutSection.module.css";
import Fader from '../../Components/Fader/Fader';

const AboutSection = ({image, header, text, link, reverse=false}) => {
    const sectionCss = reverse ? {
        flexDirection: 'row',
    } : {
        flexDirection: 'row-reverse',
    };

    return (
        <Fader>
            <div className={classesCss.about__sections__section} style={sectionCss}>
                <img src={image.src}
                     height={image.height}
                     width={image.width}
                     alt=""
                     className={classesCss.about__sections__section__image}/>
                <div className={classesCss.about__sections__section__text}>
                    <h3 className={classesCss.about__sections__section__header}>{header}</h3>
                    <p>{text}</p>
                    <a href={link.href}>{link.text.toUpperCase()}</a>

                </div>
            </div>
        </Fader>

    );
};

export default AboutSection;
